// extracted by mini-css-extract-plugin
module.exports = {"item":"BoxItem_item__24fPc"};